<div class="page-not-found">
  <h1>找不到該頁面</h1>
  <p>頁面不存在或路由錯誤。</p>
  <a routerLink="/">返回註冊首頁</a>
</div>
